// ver1.0.1

// topタブ
$(window).on('load',function(){
  var windowWidth = $(window).width();
  $('#sec_wattes .home-products__grid').insertAfter(".tab .tabContents .js-wattes");
  $('#sec_ts .home-products__grid').insertAfter(".tab .tabContents .js-ts");

  $('#sec_wattes').hide();
  $('#sec_ts').hide();

  //header pc
  $('.js-section__header .nav-global.pc-only .primary-nav__link[href="/pages/find"], .js-section__header .nav-global.pc-only .primary-nav__link[href="/pages/howto"]').parent('.primary-nav__item').remove();
});


// タブ切り替え
$(function() {
  $(".tabSwitch > li").on('click', function() {
    var $this = $(this);
    if (!$this.hasClass('active')) {
      $this.siblings().removeClass('active');
      $this.addClass('active');

      var tabNum = $this.index();
      var $tabContents = $this.closest(".tab").find(".tabContent");

      $tabContents.hide().eq(tabNum).fadeIn("500");
    }
  });
});
